import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m6.75 17.249 10.5-10.5m-9.515 5.272a4.47 4.47 0 0 0-3.417 1.3l-2.25 2.25a4.5 4.5 0 0 0 6.364 6.364l2.25-2.25a4.47 4.47 0 0 0 1.3-3.417m4.283-4.292a4.47 4.47 0 0 0 3.417-1.3l2.25-2.25a4.5 4.5 0 0 0-6.364-6.364l-2.25 2.25a4.47 4.47 0 0 0-1.295 3.417"
    }, null, -1)
  ]));
}
const interfaceHyperlink = { render };
export {
  interfaceHyperlink as default,
  render
};
//# sourceMappingURL=interface-hyperlink.svg.js.map
